













import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { LoginState, User } from '@/store/login/types';
import { RootState } from '@/store/types';
import Alert from '@/components/Alert.vue';

const namespace: string = 'login';

@Component({
  components: {
    Alert,
  },
})
export default class LoginForm extends Vue {
  @Action('login', { namespace }) private login: (user: User) => void;
  @State('login') private loginState?: LoginState;

  private user: User = { login: '', password: '' };

  constructor() {
    super();
  }

  private onLogin() {
    this.login(this.user);
  }
}
